export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/luggage.87e0085b-64469c.png";